(() => {
  const syncModelInputs = () => {
    const previewInputs = document.querySelectorAll('input[name="b2b-model-preview"]');
    const formInputs = document.querySelectorAll('input[data-b2b-model]');
    if (!previewInputs.length || !formInputs.length) return;

    const updateMatchingInput = (source, targets) => {
      targets.forEach((target) => {
        if (target.value === source.value) target.checked = source.checked;
      });
    };

    previewInputs.forEach((input) => {
      input.addEventListener('change', () => updateMatchingInput(input, formInputs));
    });
    formInputs.forEach((input) => {
      input.addEventListener('change', () => updateMatchingInput(input, previewInputs));
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncModelInputs, { once: true });
  } else {
    syncModelInputs();
  }
})();
